import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from './primitives'

const CAMP = 'h-9 w-full px-3 rounded-[var(--radius-control)] border border-line bg-surface text-[14px] focus:border-accent outline-none'

export function Camp({
  eticheta, valoare, seteaza, tip = 'text', optiuni, obligatoriu, indiciu, latime, id: idDat,
}: {
  eticheta: string
  valoare: string
  seteaza: (v: string) => void
  tip?: 'text' | 'date' | 'number' | 'email' | 'tel' | 'select' | 'textarea'
  optiuni?: { v: string; t: string }[]
  obligatoriu?: boolean
  indiciu?: string
  latime?: 'plin'
  /** Doua campuri cu aceeasi eticheta pe acelasi ecran (ora plecarii, dus si retur) ar
   *  primi acelasi id, iar eticheta a doua ar comanda primul camp. De aceea se poate da. */
  id?: string
}) {
  const id = idDat ?? 'c-' + eticheta.toLowerCase().replace(/\W+/g, '-')
  return (
    <div className={latime === 'plin' ? 'sm:col-span-2' : undefined}>
      <label htmlFor={id} className="text-[12.5px] text-muted mb-1 block">
        {eticheta}{obligatoriu && <span className="text-bad ml-0.5">*</span>}
      </label>
      {tip === 'select' ? (
        <select id={id} value={valoare} onChange={(e) => seteaza(e.target.value)} className={CAMP}>
          {optiuni?.map((o) => <option key={o.v} value={o.v}>{o.t}</option>)}
        </select>
      ) : tip === 'textarea' ? (
        <textarea id={id} value={valoare} onChange={(e) => seteaza(e.target.value)} rows={3}
          className={CAMP.replace('h-9', 'py-2 min-h-[80px]')} />
      ) : (
        <input id={id} type={tip} value={valoare} onChange={(e) => seteaza(e.target.value)} className={CAMP} />
      )}
      {indiciu && <p className="mt-1 text-[12px] text-muted">{indiciu}</p>}
    </div>
  )
}

/** Sectiune de formular, ca la TravelJoy: titlu scurt in stanga, campurile in dreapta. */
export function Sectiune({ titlu, descriere, children }: { titlu: string; descriere?: string; children: ReactNode }) {
  return (
    <section className="grid gap-5 sm:grid-cols-[200px_1fr] py-6 border-b border-line last:border-0">
      <div>
        <h3 className="text-[14.5px] font-medium">{titlu}</h3>
        {descriere && <p className="mt-1 text-[12.5px] text-muted">{descriere}</p>}
      </div>
      <div className="grid gap-4 sm:grid-cols-2 max-w-2xl">{children}</div>
    </section>
  )
}

export function BaraSalvare({
  salveaza, seSalveaza, eroare, eticheta = 'Salveaza',
}: { salveaza: () => void; seSalveaza: boolean; eroare?: string | null; eticheta?: string }) {
  const nav = useNavigate()
  return (
    <div className="sticky bottom-0 -mx-8 px-8 py-3.5 bg-surface border-t border-line flex items-center gap-3">
      <Button variant="primary" onClick={salveaza} disabled={seSalveaza}>
        {seSalveaza ? 'Se salveaza…' : eticheta}
      </Button>
      <Button variant="quiet" onClick={() => nav(-1)}>Renunta</Button>
      {eroare && <span className="text-[13px] text-bad">{eroare}</span>}
    </div>
  )
}
